import { find, get } from "lodash";
import { MDBCol, MDBContainer, MDBRow } from "mdbreact";
import React, { Component, Fragment } from "react";
import { partnerInfo } from "~/configs/partnerDetails";
import styles from "./style.module.scss";

const info = get(partnerInfo, "menu");
const findKey = find(info, { key: "gioi-thieu" });

class IntroMobileApp extends Component {
  render() {
    return (
      <Fragment>
        <div
          className={styles.main_content}
          style={{ marginTop: "calc(-7vh)" }}
        >
          <div className={styles.wapper_page_mobile}>
            <MDBContainer>
              <MDBRow>
                <MDBCol size={12}>
                  <div
                    className={styles.content}
                    dangerouslySetInnerHTML={{
                      __html: findKey.content
                    }}
                  />
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default IntroMobileApp;
